<template>
  <!-- /**
* 作用于哪些页面
* 注明代码业务/功能说明
* @authors Your Name (you@example.org)
* @date 2016-05-16
* @version $Id$
*/ -->
  <div id="app">
    <Header flag="true" v-if="isRouterAlive"></Header>
    <Menu showbg="2"></Menu>
    <!-- <keep-alive v-if="$route.meta.keepAlive && isRouterAlive"> -->
    <!-- <router-view :key="$route.name"/> -->
    <!-- </keep-alive> -->
    <!-- <router-view :key="$route.name" v-if="!$route.meta.keepAlive && isRouterAlive"/> -->
    <router-view :key="$route.name" v-if="isRouterAlive" />
    <!-- <router-view></router-view> -->
    <Bottom></Bottom>
    <modules></modules>
    <leftNav v-if="$route.name!=='home'"></leftNav>
  </div>
</template>
<script>
// import { readToken } from '@/api/apiLogin.js'
import cookie from "@/storage/cookies"

import apiUser from "@/api/apiUser/apiUser"

import localStorage from "@/storage/localStorage"
import areaFunction from "@/public/areaFunction"
// import { apiHome } from '@/api/apiHome'
import { getPosition } from "@/storage/mapPosition.js"
import userApi from "@/public/apiUser/apiUser"

export default {
  name: "home",
  mixins: [getPosition],
  components: {
    modules: () => import("@/views/Home/components/modules"),
    leftNav: () => import("@/views/Home/components/leftNav"),
    Header: () => import("@/components/public/Header"), // 头部
    // Menu: () => import('@/components/public/Menu'), // 导航菜单
    // Menu: () => import("@/components/public/RedesignMenu"), // 导航菜单
    Menu: () => import("@/components/public/NewMenu"), // 导航菜单

    Bottom: () => import("@/components/public/Bottom") // 尾部
  },
  // 使用reload刷新 在组件内 export default 下加入 inject: ['reload'],      使用 this.reload() 调用
  provide() {
    return {
      reload: this.reload
    }
  },
  data: function () {
    return {
      isRouterAlive: true
    }
  },

  // 声明reload方法，控制router-view的显示或隐藏，从而控制页面的再次加载
  methods: {
    reload() {
      this.isRouterAlive = false
      this.$nextTick(function () {
        this.isRouterAlive = true
      })
    },
    async initApp() {
      // 判断是否登录
      let cookieLogin = cookie.cookieRead("token");
      if (cookieLogin) {
        this.getUser();
        this.$store.commit("SET_LOGINTYPE", true)
      this.$store.commit("SET_TOKEN", cookieLogin)
      }
    },
    async getUser() {
      // 获取用户信息
      let user = await apiUser.getUserInfo()
      this.$store.commit("SET_USER", user.data.data)
      let token = cookie.cookieRead("token")
      this.$store.commit("SET_LOGINTYPE", true)
      this.$store.commit("SET_TOKEN", token)
      // this.$store.commit('SET_USER', user)
    },
    async judgeArea() {
      // 判断cookie是否需要修改
      let area = cookie.cookieRead("area")
      let bol = area && area !== undefined
      let bol2
      // 存在 cookie
      if (bol) {
        bol2 = JSON.parse(area).shortName === undefined // cookie 为旧数据
        if (!bol2) {
          // 新数据 不需要修改 存入地区列表
          let data = {
            cookie: JSON.parse(area),
            has: true
          }
          this.judgeAreaList(data)
        } else {
          // 旧数据
          let data = {
            cookie: {},
            has: false
          }
          this.judgeAreaList(data)
        }
        return
      }
      // 使用定位选择当前城市
      let data = {
        cookie: {},
        has: false
      }
      this.judgeAreaList(data)
    },
    async judgeAreaList(data) {
      // 判断 localStorage是否修改 false为修改
      let change = {
        cookie: false,
        localStorage: false
      }

      let bol1 = data.has // 是否存在 cookie
      if (bol1) {
        change.cookie = true
      }

      let areaAll = localStorage.read("areaAll")
      let bol2 = areaAll && areaAll !== undefined // 是否存在地区列表
      if (bol2) {
        let bol3 = JSON.parse(areaAll)[0].shortName === undefined // 是否是旧数据
        if (!bol3) {
          // 存在 新地区列表 不需要修改
          change.localStorage = true
        }
        if (bol1 && bol2 && !bol3) {
          let oldArea = JSON.parse(cookie.cookieRead("area"))
          let oldAreaAll = JSON.parse(areaAll)
          for (let i = 0; i < oldAreaAll.length; i++) {
            if (oldAreaAll[i].checked) {
              if (oldAreaAll[i].shortName !== oldArea.shortName) {
                change.localStorage = false
                break
              }
            }
          }
        }
      }
      //
      // 不需要修改cookie 个localStorage
      if (change.cookie && change.localStorage) {
        // 不需要修改
        return
      }
      //
      let areaList = []
      if (!change.localStorage) {
        // 需要修改localStorage
        areaList = await areaFunction.setAreaList()
      } else {
        // 不需要修改localStorage
        areaList = JSON.parse(areaAll)
      }
      this.changeArea(areaList, !change.cookie, !change.localStorage)
    },
    changeArea(List, bol1, bol2) {
      // 参数为 地区数组 是否需要修改 cookie 是否需要修改 localStorage
      // 修改cookie 和 localStorage
      if (bol1 && bol2) {
        for (let i = 0; i < List.length; i++) {
          if (List[i].checked) {
            let area = JSON.stringify(List[i])
            cookie.cookieSet("area", area)
            localStorage.set("areaAll", JSON.stringify(List))
            break
          }
        }
        return
      }
      // 修改cookie
      if (bol1) {
        let area = cookie.cookieRead("area")
        let bol = area && area !== undefined
        if (bol) {
          let oldArea = JSON.parse(area)
          for (let i = 0; i < List.length; i++) {
            if (List[i].id === oldArea.id) {
              let newArea = JSON.stringify(List[i])
              cookie.cookieSet("area", newArea)
              break
            }
          }
        } else {
          for (let i = 0; i < List.length; i++) {
            if (List[i].checked) {
              let newArea = JSON.stringify(List[i])
              cookie.cookieSet("area", newArea)
              break
            }
          }
        }

        return
      }
      // 修改 localStorage
      if (bol2) {
        let oldArea = JSON.parse(cookie.cookieRead("area"))
        for (let i = 0; i < List.length; i++) {
          if (List[i].id === oldArea.id) {
            List[i].checked = true
          } else {
            List[i].checked = false
          }
        }
        localStorage.set("areaAll", JSON.stringify(List))
      }
    },
    //检查用户登录状态
    async checkUserType() {
      console.log(
        JSON.parse(window.localStorage.getItem("isLoginType")),
        "99999999999999999"
      )
      const state = JSON.parse(window.localStorage.getItem("isLoginType"))
      if (!state) {
        console.log("我注销了")
        await userApi.logOut()
        this.$store.dispatch("zjkjIm/logout")
        this.$store.commit("LOGIN_OUT")
      }
    }
  },
  async created() {
    // this.checkUserType()
    this.$nextTick(function () {
      this.initApp();
    });
    // await this.getUser()
    /** @name 页面加载时读取sessionStorage里的状态信息 */
    if (sessionStorage.getItem("store")) {
      this.$store.replaceState(
        Object.assign(
          {},
          this.$store.state,
          JSON.parse(sessionStorage.getItem("store"))
        )
      )
    }
    /** @name 页面刷新时将vuex里的信息保存到sessionStorage里 */
    window.addEventListener("beforeunload", () => {
      sessionStorage.setItem("store", JSON.stringify(this.$store.state))
    })

    this.judgeArea()
    if (cookie.cookieRead("token")) {
      this.$store.dispatch("setUser")
    }

    this.initGdMap()
  }
}
</script>
<style lang="scss">
@import "../src/styles/static-style";
@import "../src/styles/main";
</style>
<style lang="scss">
i.el-icon-circle-close {
  color: white !important;
}
.el-cascader .el-input .el-icon-circle-close {
  color: #909399 !important;
}
.el-tooltip__popper.is-dark {
  max-width: 400px;
}
.el-message{
  width: 820px;
}
</style>
